import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isSubmitProjectReportRequestFailure({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isSubmitProjectReportRequestPending({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isSubmitProjectReportRequestSuccess({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
